import script from "./mvt-reorder.vue?vue&type=script&lang=js"
export * from "./mvt-reorder.vue?vue&type=script&lang=js"

import "./mvt-reorder.vue?vue&type=style&index=0&id=154afa6e&lang=scss"

const __exports__ = script;

export default __exports__